import { usePumpSizing } from "../../context/PumpSizingContext";
import { StepApplicationType } from "./StepApplicationType";
import { StepGpm } from "./StepGpm";
import { StepPumpCurve } from "./StepPumpCurve";
import { StepTdh } from "./StepTdh";

export function StepContent() {
	const { currentStep } = usePumpSizing();

	switch (currentStep) {
		case 1:
			return <StepApplicationType />;
		case 2:
			return <StepGpm />;
		case 3:
			return <StepTdh />;
		case 4:
			return <StepPumpCurve />;
		default:
			return null;
	}
}
